import { Component } from "@angular/core";

@Component({
    selector: "forbidden",
    templateUrl: "./forbidden.component.html",
})
export class ForbiddenComponent {}
